import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import GetInTouch from '../Components/Contact/GetInTouch'
import ContactOne from '../Components/Contact/ContactOne'
import ContactMap from '../Components/Contact/ContactMap'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Contact() {
    const { t } = useTranslation()
    
    return (
        <>
            <SEO 
                title={t("seo.contact.title")}
                description={t("seo.contact.description")}
                url="/contact"
            />
            <HeaderOne />
            <Breadcrumb
                title={t("contact.title")}
            />
            <GetInTouch />
            <ContactOne />
            <ContactMap />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Contact
